import { useAdaptFileUrl } from '@unifyapps/network/hooks/useAdaptFileUrl';
import { Image as BaseImage } from '@unifyapps/ui/components/Image';
import type { ComponentProps } from 'react';

function Image(props: ComponentProps<typeof BaseImage>) {
  const { src, ...rest } = props;
  const adaptFileUrl = useAdaptFileUrl();

  return <BaseImage {...rest} src={typeof src === 'string' ? adaptFileUrl(src) : undefined} />;
}

export default Image;
